import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCog = (props: SvgProps) => (
  <Svg fill="none" height={25} width={25} {...props}>
    <Path
      clipRule="evenodd"
      d="M11.63.489a1 1 0 0 0-1 1v1.2A9.9 9.9 0 0 0 7.27 4.045l-.877-.877a1 1 0 0 0-1.414 0L3.31 4.839a1 1 0 0 0 0 1.414l.877.877a9.9 9.9 0 0 0-1.356 3.359h-1.2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1.2a10 10 0 0 0 1.355 3.359l-.876.876a1 1 0 0 0 0 1.415L4.98 21.81a1 1 0 0 0 1.414 0l.877-.877a9.9 9.9 0 0 0 3.359 1.356v1.2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.2a9.9 9.9 0 0 0 3.359-1.356l.876.877a1 1 0 0 0 1.415 0l1.67-1.672a1 1 0 0 0 0-1.414l-.876-.876a9.9 9.9 0 0 0 1.356-3.359h1.2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1.2a9.9 9.9 0 0 0-1.356-3.359l.877-.876a1 1 0 0 0 0-1.415l-1.672-1.67a1 1 0 0 0-1.414 0l-.876.876a9.9 9.9 0 0 0-3.36-1.356v-1.2a1 1 0 0 0-1-1zm1 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCog);
export default Memo;
